<template>
  <v-card class="rsl-fixed-height">
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        :label="$t('CASES.HISTORIC.SEARCH_TEXT')"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-btn
        small
        class="mr-2"
        color="success"
        @click="clearDates()"
      >{{ $t('CASES.HISTORIC.BTNS.CLEAR_DATES') }}</v-btn>
      <v-btn
        small
        class="mr-2"
        color="error"
        @click="bulkDelete(selected)"
        :disabled="selected.length == 0"
      >{{ $t('CASES.HISTORIC.BTNS.BULK_DELETE') }}</v-btn>
    </v-card-title>
    <v-row class="mx-2">
      <v-col cols="12" lg="6" md="6">
        <v-dialog
          ref="histStartedBefore"
          v-model="histStartedBefore"
          :return-value.sync="startedBefore"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedStartedBefore"
              :label="$t('CASES.HISTORIC.FIELDS.STARTED_BEFORE')"
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="$t('GENERAL.LOCALE')"
            v-model="startedBefore"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="histStartedBefore = false"
            >
              {{ $t('GENERAL.BTNS.CANCEL') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.histStartedBefore.save(startedBefore)"
            >
              {{ $t('GENERAL.BTNS.OK') }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" lg="6" md="6">
        <v-dialog
          ref="histStartedAfter"
          v-model="histStartedAfter"
          :return-value.sync="startedAfter"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedStartedAfter"
              :label="$t('CASES.HISTORIC.FIELDS.STARTED_AFTER')"
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="$t('GENERAL.LOCALE')"
            v-model="startedAfter"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="histStartedAfter = false"
            >
              {{ $t('GENERAL.BTNS.CANCEL') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.histStartedAfter.save(startedAfter)"
            >
              {{ $t('GENERAL.BTNS.OK') }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
    </v-row>
    <v-row class="mx-2">  
      <v-col cols="12" lg="6" md="6">
        <v-dialog
          ref="histFinishedBefore"
          v-model="histFinishedBefore"
          :return-value.sync="finishedBefore"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedFinishedBefore"
              :label="$t('CASES.HISTORIC.FIELDS.FINISHED_BEFORE')"
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="$t('GENERAL.LOCALE')"
            v-model="finishedBefore"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="histFinishedBefore = false"
            >
              {{ $t('GENERAL.BTNS.CANCEL') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.histFinishedBefore.save(finishedBefore)"
            >
              {{ $t('GENERAL.BTNS.OK') }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" lg="5" md="5">
        <v-dialog
          ref="histFinishedAfter"
          v-model="histFinishedAfter"
          :return-value.sync="finishedAfter"
          persistent
          width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="computedFinishedAfter"
              :label="$t('CASES.HISTORIC.FIELDS.FINISHED_AFTER')"
              prepend-icon="mdi-calendar"
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            :locale="$t('GENERAL.LOCALE')"
            v-model="finishedAfter"
            scrollable
          >
            <v-spacer></v-spacer>
            <v-btn
              text
              color="primary"
              @click="histFinishedAfter = false"
            >
              {{ $t('GENERAL.BTNS.CANCEL') }}
            </v-btn>
            <v-btn
              text
              color="primary"
              @click="$refs.histFinishedAfter.save(finishedAfter)"
            >
              {{ $t('GENERAL.BTNS.OK') }}
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-col>
      <v-col cols="12" lg="1" md="2">
        <v-btn
          class="mt-3"
          color="primary"
          @click="refreshProcesses()"
        >
          {{ $t('CASES.HISTORIC.BTNS.REFRESH') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="items"
      :items-per-page="25"
      :footer-props="{'items-per-page-options':[25, 50, 100, -1]}"
      :search="search"
      class="elevation-1 mx-3 mb-3"
      item-key="id"
      :sort-by="sortBy"
      :sort-desc="sortDesc"
      loading-text="Loading... Please wait"
      :loading="loading"
      show-select
    >
      <template slot="item.actions" slot-scope="row">
        <v-btn
          small
          class="mr-2"
          color="success"
          @click="viewInstance(row.item)"
        >
          {{ $t('GENERAL.BTNS.VIEW') }}
        </v-btn>
        <v-btn
          small
          class="mr-2"
          color="error"
          @click="deleteInstance(row.item)"
        >
          {{ $t('GENERAL.BTNS.DELETE') }}
        </v-btn>
      </template>
    </v-data-table>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="deleteDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ deleteTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5 warning-text">{{ deleteText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="deleteDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmDelete({instanceId})"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>

    <v-dialog
        transition="dialog-bottom-transition"
        max-width="400"
        v-model="bulkDeleteDialog"
        :retain-focus="false"
      >
      <template>
        <v-card>
          <v-toolbar
            color="#f87723"
            dark
          >{{ bulkDeleteTitle }}</v-toolbar>
          <v-card-text>
            <div class="pt-5 warning-text">{{ bulkDeleteText }}</div>
          </v-card-text>
          <v-card-actions>
            <v-btn
              text
              @click="bulkDeleteDialog = false"
            >{{ $t('GENERAL.BTNS.CANCEL') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn
              text
              @click="confirmBulkDelete(selected)"
            >{{ $t('GENERAL.BTNS.CONFIRM') }}</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
  </v-card>
</template>

<script>
  import $ from 'jquery';
  import { mapGetters } from 'vuex';
  export default {
    name: 'historiccases',
    computed: {
      ...mapGetters(['completedInstances', 'savedStartedBefore', 'savedStartedAfter', 'savedFinishedBefore', 'savedFinishedAfter', 'histDatesCleared']),
      computedStartedBefore () {
        return this.formatDate(this.startedBefore)
      },
      computedStartedAfter () {
        return this.formatDate(this.startedAfter)
      },
      computedFinishedBefore () {
        return this.formatDate(this.finishedBefore)
      },
      computedFinishedAfter () {
        return this.formatDate(this.finishedAfter)
      },
    },
    data: function() {
      return {
        loading: false,
        histStartedBefore: '',
        startedBefore: '',
        histStartedAfter: '',
        startedAfter: '',
        histFinishedBefore: '',
        finishedBefore: '',
        histFinishedAfter: '',
        finishedAfter: '',
        deleteDialog: false,
        deleteTitle: '',
        deleteText: '',
        bulkDeleteDialog: false,
        bulkDeleteTitle: '',
        bulkDeleteText: '',
        instanceId: '',
        search: '',
        selected: [],
        sortBy: '',
        sortDesc: false,
        theCaseId: 0,
        theProcessName: '',
        headers: [
          { 
            text: this.$t('CASES.FIELDS.CASE_ID'), 
            align: 'start',
            sortable: true,
            value: 'caseId' 
          },
          { text: this.$t('CASES.FIELDS.PROCESS_NAME'), sortable: true, value: 'processDefinitionName' },
          { text: this.$t('CASES.HISTORIC.FIELDS.START_TIME'), value: 'startTime', sortable: false },
          { text: this.$t('CASES.HISTORIC.FIELDS.END_TIME'), value: 'endTime', sortable: false },
          { text: this.$t('CASES.FIELDS.ACTIONS'), value: 'actions', sortable: false }
        ],
        items: []
      }
    },
    created() {
      if(this.savedStartedBefore != '' || this.savedStartedAfter != '' || this.savedFinishedBefore != '' || this.savedFinishedAfter != '') {
        if(this.savedStartedBefore != '') {
          this.startedBefore = this.savedStartedBefore;
        }
        if(this.savedStartedAfter != '') {
          this.startedAfter = this.savedStartedAfter;
        }
        if(this.savedFinishedBefore != '') {
          this.finishedBefore = this.savedFinishedBefore;
        }
        if(this.savedFinishedAfter != '') {
          this.finishedAfter = this.savedFinishedAfter;
        }
      }else {
        if(!this.histDatesCleared) {
          let current = new Date();
          let target = current.setMonth(current.getMonth() - 1);
          let df = new Date(target);
          this.startedAfter = df.toISOString().split('T')[0]
        }
      }
      this.refreshProcesses();

      this.unsubscribe = this.$store.subscribe((mutation) => {

        if(mutation.type === 'BULK_DELETION') {
          this.refreshProcesses();
        }

      });
    },
    beforeDestroy() {
      this.unsubscribe();
    },
    methods: {
      clearDates() {
        this.startedBefore = '';
        this.startedAfter = '';
        this.finishedBefore = '';
        this.finishedAfter = '';
        this.$store.commit('HIST_DATES_CLEARED', true);
        this.$store.commit('SAVED_STARTED_BEFORE', this.startedBefore);
        this.$store.commit('SAVED_STARTED_AFTER', this.startedAfter);
        this.$store.commit('SAVED_FINISHED_BEFORE', this.finishedBefore);
        this.$store.commit('SAVED_FINISHED_AFTER', this.finishedAfter);
      },
      formatDate(date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      refreshProcesses() {
        this.loading = true;
        let sb = '';
        let sa = '';
        let fb = '';
        let fa = '';

        if(this.startedBefore) {
          sb = new Date(this.startedBefore);
          this.$store.commit('SAVED_STARTED_BEFORE', sb.toISOString().split('T')[0]);
          sb = sb.toISOString();
          sb = sb.replace('Z', '+0000');
        }
        if(this.startedAfter) {
          sa = new Date(this.startedAfter);
          this.$store.commit('SAVED_STARTED_AFTER', sa.toISOString().split('T')[0]);
          sa = sa.toISOString();
          sa = sa.replace('Z', '+0000');
        }
        if(this.finishedBefore) {
          fb = new Date(this.finishedBefore);
          this.$store.commit('SAVED_FINISHED_BEFORE', fb.toISOString().split('T')[0]);
          fb = fb.toISOString();
          fb = fb.replace('Z', '+0000');
        }
        if(this.finishedAfter) {
          fa = new Date(this.finishedAfter);
          this.$store.commit('SAVED_FINISHED_AFTER', fa.toISOString().split('T')[0]);
          fa = fa.toISOString();
          fa = fa.replace('Z', '+0000');
        }

        let payload = {
          'startedBefore': sb,
          'startedAfter': sa,
          'finishedBefore': fb,
          'finishedAfter': fa
        }
        this.$store.dispatch('getCompletedInstances', payload).then( () => {
          this.items = this.completedInstances;
          this.loading = false;
          // Apply sort field and order
          let field = this.$store.state.historicCasesSortField;
          let sort = this.$store.state.historicCasesSortOrder;
          if(field == null) {
            this.sortBy = 'caseId';
            this.sortDesc = true;
          }else if (sort == 'none') {
            this.sortBy = '';
            this.sortDesc = false;
          }else {
            this.sortBy = field;

            if(sort == 'descending') {
              this.sortDesc = true;
            }else {
              this.sortDesc = false;
            }
          }
          // Remove previous click events
          $('.text-start.sortable').off();
          // Add new click events for storing order
          let ref = this;
          $('.text-start.sortable').click(function() {
            let column = $(this)[0].firstChild.innerHTML;
            let order = $(this).attr('aria-sort');
            
            for(let i = 0; i < ref.headers.length; i++) {
              if(column == ref.headers[i].text) {
                ref.$store.commit('setHistoricCasesSortField', ref.headers[i].value);
                ref.$store.commit('setHistoricCasesSortOrder', order);
              }
            }
          });
        });
      },
      viewInstance(item) {
        this.$store.commit('UPDATE_INSTANCE_ID', item.id);
        this.$store.commit('UPDATE_HISTORIC_CASE_ID', item.caseId);
        this.$router.push({ name: 'ViewCaseHistory' });
      },
      deleteInstance(item) {
        this.deleteTitle = this.$t('CASES.HISTORIC.DELETE_CASE.TITLE');
        this.deleteText = this.$t('CASES.HISTORIC.DELETE_CASE.DESC_1') + item.caseId + '. ' + this.$t('CASES.HISTORIC.DELETE_CASE.DESC_2');
        this.instanceId = item.id;
        this.theCaseId = item.caseId;
        this.theProcessName = item.processDefinitionName;
        this.deleteDialog = true;
      },
      confirmDelete(item) {
        this.deleteDialog = false;
        let payload = {
          'id': item.instanceId
        }
        this.$store.dispatch('deleteHistoricProcessInstance', payload).then( () => {
          this.updateLog('Historic', 'Deleted', this.theCaseId, this.theProcessName, 'Historic case ' + this.theCaseId + ' deleted.');
          this.refreshProcesses();
        });
      },
      bulkDelete(items) {
        this.bulkDeleteTitle = this.$t('CASES.HISTORIC.BULK_DELETE.TITLE');
        this.bulkDeleteText = this.$t('CASES.HISTORIC.BULK_DELETE.DESC_1') + ' ' + items.length + ' ' + this.$t('CASES.HISTORIC.BULK_DELETE.DESC_2');
        this.bulkDeleteDialog = true;
      },
      confirmBulkDelete(items) {
        this.bulkDeleteDialog = false;
        let payload = {
          'items': items
        }
        this.$store.dispatch('bulkDeleteHistoricProcessInstance', payload).then( () => {
          for(let i = 0; i < items.length; i++) {
            this.updateLog('Historic', 'Deleted', items[i].caseId, items[i].processDefinitionName, 'Historic case ' + items[i].caseId + ' deleted.');
          }
          this.selected = [];
        });
      },
      updateLog(cat, op, caseId, process, msg) {
        let dt = new Date();
        let dateTime = new Intl.DateTimeFormat('en-GB', 
          {
            day: 'numeric',
            month: 'numeric', 
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false
          }).format(dt);

        if(caseId == null) {
          caseId = 0;
        }

        let logData = {
          'category': cat,
          'userId': this.$store.state.currentUser,
          'caseId': caseId,
          'processName': process,
          'taskName': null,
          'operation': op,
          'msg': msg,
          'dateTime': dateTime,
        };
        this.$store.dispatch('updateOpLog', logData);
      }
    },
  }
</script>
